import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';

import CreditorsContact from '../CreditorsContact/CreditorsContact';

import './Creditors.scss';

const Creditors = ({ creditors }) => (
  <Paper className="creditors">
    <div className="creditors__title">
      Creditors
    </div>
    <div className="creditors__items">
      {creditors.map(({
        dateFiled,
        id,
        noticeParty,
        party,
        paymentParty,
        percentOfAmount,
      }) => (
        <div
          className="creditors__item"
          key={id}
        >
          <div className="creditors__main-section">
            <div className="creditors__group">
              <div className="creditors__label">
                Party:
              </div>
              <div className="creditors__value">
                {party}
              </div>
            </div>
            <div className="creditors__group">
              <div className="creditors__label">
                Date filed:
              </div>
              <div className="creditors__value">
                {moment(dateFiled).format('L')}
              </div>
            </div>
            <div className="creditors__group">
              <div className="creditors__label">
                % of amount paid:
              </div>
              <div className="creditors__value">
                {percentOfAmount}
              </div>
            </div>
          </div>
          <div className="creditors__flex-section">
            {noticeParty && (
              <div className="creditors__contact-box">
                <CreditorsContact
                  name={noticeParty.name}
                  address={noticeParty.address}
                  title="Notice - contact details"
                />
              </div>
            )}
            {paymentParty && (
              <div className="creditors__contact-box">
                <CreditorsContact
                  name={paymentParty.name}
                  address={paymentParty.address}
                  title="Payment - contact details"
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </Paper>
);

Creditors.propTypes = {
  creditors: PropTypes.arrayOf(PropTypes.shape({
    dateFiled: PropTypes.string,
    id: PropTypes.number,
    noticeParty: PropTypes.object,
    party: PropTypes.string,
    paymentParty: PropTypes.object,
    percentOfAmount: PropTypes.string,
  })).isRequired,
};

export default Creditors;



// WEBPACK FOOTER //
// ./src/routes/Case/Claims/ClaimDetails/components/Creditors/Creditors.js